module.exports = __webpack_public_path__ + "static/media/Super Combo_Web2025.35418574.png";